import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
        <path d="M6 6 h24 a8 8 0 0 1 0 16 h-28 a9 9 0 0 1 4 -16 z" fill="#60A5FA" />
        <path d="M6 20 h19 a8 8 0 0 1 0 16 h-23 a9 9 0 0 1 4 -16 z" fill="#2563EB" />
        <path d="M6 34 h13 a8 8 0 0 1 0 16 h-17 a9 9 0 0 1 4 -16 z" fill="#60A5FA" opacity="0.85" transform="translate(0,-6)" />
    </svg>
);

export const Logo = ({ dark = false }) => (
    <Link
        to="/"
        data-testid="logo-link"
        className="flex items-center gap-2.5"
        aria-label="FlowPilot home"
    >
        <LogoMark />
        <span
            className={`text-xl font-bold tracking-tight ${
                dark ? "text-white" : "text-[#0B1F44]"
            }`}
        >
            Flow<span className="text-[#2563EB]">Pilot</span>
        </span>
    </Link>
);
